import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { removeDecisionFolder } from '../state/actions';
import { FolderSelectionType } from '../dropdown/foldersDropdown.types';

type Props = {
  docId: string;
  folder: FolderSelectionType;
};

const mapDispatch = (
  dispatch: ThunkDispatch<{}, {}, AnyAction>,
  { docId, folder }: Props,
) => ({
  onRemoveClicked() {
    dispatch(removeDecisionFolder(docId, folder.folderKey, 'folders-page'));
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
